import gql from 'graphql-tag';

import GraphQLClient from '../../adapter/GraphQLClient';
import Language from '../../entity/Language';
import { ProjectTypeDetailFragment, ProjectTypeForListFragment } from '../../generated/graphql';

const projectTypeForListFragment = gql`
  fragment ProjectTypeForList on ProjectType {
    id
    key
    title
    description
    thumbnailImageUrl
    sampleVideoUrl
    expectedDeliveryPeriod
    outputSpecification
    regulation
    createdAt
    popularity
    displayPriority
    minimumPoint
    supportingCreativeFormatNetworks {
      id
      key
      name
      placements {
        id
        key
        name
        creativeTypes {
          id
          key
          name
        }
      }
    }
    matchingFormatGroup {
      availableFormats
    }
  }
`;

class ProjectTypeWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getAllByOrganization = async ({
    language,
    organizationId,
  }: {
    language: Language;
    organizationId: string;
  }): Promise<Array<ProjectTypeForListFragment>> => {
    const data = await this.graphqlClient.query(
      gql`
        ${projectTypeForListFragment}
        query getProjectTypesByRegion($language: ID!, $organizationId: ID) {
          projectTypes(language: $language, organizationId: $organizationId, first: 100) {
            edges {
              node {
                ...ProjectTypeForList
              }
            }
          }
        }
      `,
      { language, organizationId },
    );

    if (!Array.isArray(data.projectTypes.edges)) {
      throw new Error('message.fetch_creations_has_failed');
    }

    return data.projectTypes.edges.map((edge: any) => edge.node as ProjectTypeForListFragment);
  };

  public getByKey = async (key: string, { language }: { language: Language }): Promise<ProjectTypeDetailFragment> => {
    const result = await this.graphqlClient.query(
      gql`
        query getProjectType2($key: String!, $language: ID!) {
          projectType(key: $key, language: $language) {
            ...ProjectTypeDetail
          }
        }
      `,
      { key, language },
    );

    return result.projectType as ProjectTypeDetailFragment;
  };
}

export default ProjectTypeWebApi;
